import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["aspectRatio", "overrideLoading", "visible"];
import React from 'react';
import styled, { css } from 'styled-components';
import { positionAbsolute } from '../../styling';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Image__Wrapper",
  componentId: "sc-15x4a1u-0"
})(["width:100%;> div{width:100%;height:0;padding-top:", "%;position:relative;}"], function (_ref) {
  var $aspectRatio = _ref.$aspectRatio;
  return 100 / $aspectRatio;
});
var Picture = /*#__PURE__*/styled.picture.withConfig({
  displayName: "Image__Picture",
  componentId: "sc-15x4a1u-1"
})(["img{position:absolute;top:0;left:0;width:100%;pointer-events:none;}", ""], function (_ref2) {
  var $isBgImage = _ref2.$isBgImage;
  return $isBgImage && css(["", ";img{object-fit:cover;height:100%;width:100%;}"], positionAbsolute());
});

var Image = function Image(_ref3) {
  var src = _ref3.src,
      alt = _ref3.alt,
      _ref3$isBgImage = _ref3.isBgImage,
      isBgImage = _ref3$isBgImage === void 0 ? false : _ref3$isBgImage;
  var isSvg = src === null || src === void 0 ? void 0 : src.includes('.svg');
  return /*#__PURE__*/React.createElement(Picture, {
    $isBgImage: isBgImage
  }, !isSvg && /*#__PURE__*/React.createElement("source", {
    srcSet: "".concat(src, "?fm=webp&q=100"),
    type: "image/webp"
  }), /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt || '',
    role: alt ? undefined : 'presentation'
  }));
};

var ImageWrapper = function ImageWrapper(_ref4) {
  var aspectRatio = _ref4.aspectRatio,
      overrideLoading = _ref4.overrideLoading,
      visible = _ref4.visible,
      rest = _objectWithoutProperties(_ref4, _excluded);

  var renderImage = overrideLoading || visible;
  if (aspectRatio) return /*#__PURE__*/React.createElement(Wrapper, {
    $aspectRatio: aspectRatio
  }, /*#__PURE__*/React.createElement("div", null, renderImage && /*#__PURE__*/React.createElement(Image, rest)));
  return renderImage ? /*#__PURE__*/React.createElement(Image, rest) : null;
};

export default ImageWrapper;